module.exports = __webpack_public_path__ + "img/横向中线对齐2.51357717.svg";